import { ChevronLeft } from '@mui/icons-material';
import { SxProps, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface BackLinkProps {
  label: string;
  sx?: SxProps;
  to: string;
}

const BackLink = ({ label, to, sx = {} }: BackLinkProps) => (
  <Typography
    component={RouterLink}
    to={to}
    sx={{ color: 'text.primary', display: 'inline-block', whiteSpace: 'nowrap', textDecoration: 'none', ...sx }}
  >
    <ChevronLeft sx={{ verticalAlign: 'middle', mr: 3 }} /> {label}
  </Typography>
);

export default BackLink;
